module.exports = __webpack_public_path__ + "img/mlokhya-khadra.0c73181c.png";